import React, { useContext, useState } from "react";
import { ThemeContext } from "../../../ThemeProvider";
import classes from "./Tabs.module.css";

const Tabs = ({ toggleState, toggleHandler, toggleNum, name }) => {
  const { dark } = useContext(ThemeContext);

  const active__tab__className = () => {
    if (toggleState === toggleNum) {
      return dark
        ? `${classes.tab} ${classes.activeTab__dark}`
        : `${classes.tab} ${classes.activeTab}`;
    } else {
      return classes.tab;
    }
  };

  return (
    <p
      onClick={() => toggleHandler(toggleNum)}
      className={active__tab__className()}
    >
      {name}
    </p>
  );
};

export default Tabs;
